export default "__VITE_ASSET__BWDO$U90__"